import { render, staticRenderFns } from "./downloadApps.vue?vue&type=template&id=641032ec&scoped=true"
import script from "./downloadApps.vue?vue&type=script&lang=js"
export * from "./downloadApps.vue?vue&type=script&lang=js"
import style0 from "./downloadApps.vue?vue&type=style&index=0&id=641032ec&prod&lang=scss&scoped=true"
import style1 from "./downloadApps.vue?vue&type=style&index=1&id=641032ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641032ec",
  null
  
)

export default component.exports